var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.textEmpty)?_c('span',{style:(_vm.appearanceOverrides)},[(_vm.text)?[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]:[_vm._t("default")]],2):_c('KEmptyPlaceholder')
}
var staticRenderFns = []

export { render, staticRenderFns }